function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 318.188 318.188",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8E8E8"
    },
    points: "227.321,7.5 40.342,7.5 40.342,310.688 277.846,310.688 277.846,58.025  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.317,
    y: 173.87,
    style: {
      fill: "#38A3FF"
    },
    width: 49.543,
    height: 12.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.317,
    y: 149.229,
    style: {
      fill: "#38A3FF"
    },
    width: 107.543,
    height: 12.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.317,
    y: 124.587,
    style: {
      fill: "#38A3FF"
    },
    width: 117.551,
    height: 12.865
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38A3FF"
    },
    d: "M125.167,111.717c-1.26,0-2.437-0.764-2.92-1.987c-2.487-6.298-8.172-6.909-11.333-6.712 c-5.387,0.333-9.65,3.229-10.106,4.997c-0.434,1.679-2.147,2.69-3.826,2.255c-1.679-0.433-2.689-2.146-2.256-3.825 c1.304-5.05,8.097-9.219,15.801-9.695c4.568-0.29,8.63,0.842,11.824,3.146c1.079-4.168,3.516-7.706,7.164-10.229 c5.815-4.021,13.649-4.619,19.046-1.454c1.497,0.877,1.999,2.802,1.122,4.298c-0.878,1.497-2.804,1.996-4.298,1.121 c-3.26-1.91-8.546-1.393-12.298,1.202c-4.083,2.823-5.795,7.516-4.822,13.213c0.271,1.586-0.7,3.12-2.25,3.554 C125.732,111.679,125.447,111.717,125.167,111.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38A3FF"
    },
    d: "M126.052,86.429c-0.782,0-1.511-0.474-1.812-1.232c-1.542-3.905-5.064-4.281-7.027-4.163 c-3.34,0.207-5.984,2.003-6.268,3.1c-0.269,1.041-1.331,1.669-2.372,1.398c-1.042-0.268-1.668-1.33-1.4-2.372 c0.809-3.132,5.021-5.717,9.799-6.013c2.831-0.176,5.352,0.521,7.333,1.951c0.668-2.586,2.18-4.779,4.442-6.343 c3.607-2.493,8.465-2.865,11.812-0.903c0.929,0.545,1.24,1.738,0.696,2.666c-0.543,0.928-1.737,1.24-2.665,0.695 c-2.02-1.186-5.299-0.863-7.626,0.746c-2.532,1.751-3.595,4.66-2.99,8.193c0.167,0.982-0.435,1.936-1.396,2.205 C126.402,86.405,126.227,86.429,126.052,86.429z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#38A3FF"
    },
    points: "235.14,32.763 40.342,32.763 40.342,7.5 227.321,7.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D3D3"
    },
    points: "227.321,58.025 277.846,58.025 227.321,7.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M283.149,52.723L232.625,2.197C231.218,0.79,229.311,0,227.321,0H40.342c-4.142,0-7.5,3.358-7.5,7.5 v303.188c0,4.143,3.358,7.5,7.5,7.5h237.504c4.143,0,7.5-3.357,7.5-7.5V58.025C285.346,56.036,284.556,54.129,283.149,52.723z  M234.821,25.606l24.918,24.919h-24.918L234.821,25.606L234.821,25.606z M47.842,15h171.979v10.263H47.842V15z M270.346,303.188 H47.842V40.263h171.979v17.763c0,4.143,3.357,7.5,7.5,7.5h43.024v237.662H270.346z M162.4,233.392h-16.606v47.979h15.523 c7.985,0,14.183-2.166,18.591-6.498s6.613-10.502,6.613-18.509c0-7.438-2.096-13.127-6.285-17.065 C176.047,235.361,170.102,233.392,162.4,233.392z M170.31,267.309c-1.838,2.287-4.726,3.43-8.664,3.43h-2.888v-26.877h3.773 c3.545,0,6.187,1.061,7.926,3.183s2.609,5.382,2.609,9.78C173.066,261.527,172.147,265.023,170.31,267.309z M191.608,243.992 h11.716v37.379h12.963v-37.379h11.683v-10.601h-36.361v10.601H191.608z M113.863,232.637c-7.614,0-13.417,2.106-17.41,6.318 c-3.993,4.211-5.989,10.31-5.989,18.295c0,8.073,2.007,14.222,6.022,18.443c4.015,4.223,9.785,6.334,17.311,6.334 c7.635,0,13.434-2.1,17.394-6.301c3.959-4.201,5.94-10.338,5.94-18.41c0-8.096-1.969-14.232-5.907-18.411 C127.286,234.726,121.499,232.637,113.863,232.637z M121.1,267.85c-1.586,2.254-4.02,3.381-7.302,3.381 c-6.454,0-9.681-4.639-9.681-13.914c0-9.364,3.249-14.047,9.747-14.047c3.194,0,5.595,1.145,7.204,3.43 c1.608,2.287,2.412,5.825,2.412,10.617C123.479,262.086,122.686,265.598,121.1,267.85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdt);
export default __webpack_public_path__ + "static/media/odt.2d180a7907583fd9daf1aad8661f5341.svg";
export { ForwardRef as ReactComponent };